<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="logo" style="text-align: center; margin: 25px auto">
          <img
            style="max-width: 300px"
            src="https://www.sarexpress.com/assets/img/navbar-logo.svg"
          />
        </div>
        <h2 style="text-align: center; color: #000">Olvide mi contraseña</h2>
      </div>
    </div>
    <div v-if="!exito" class="row">
      <div style="max-width: 330px; margin: auto">
        <p class="text-center" style="color: #000; line-height: 1.35">
          Utilice el siguiente formulario para recuperar su contraseña.
        </p>
        <form method="post" id="passwordForm" @submit="submit">
          <input
            v-model="email"
            type="email"
            class="input-lg form-control"
            name="email"
            id="email"
            placeholder="Email"
            autocomplete="off"
          />
          <p
            v-if="error"
            class="text-center"
            style="color: #000; line-height: 1.35"
          >
            {{ error }}
          </p>
          <button
            type="submit"
            class="col-12 btn btn-primary btn-lg"
            style="margin-top: 10px"
            data-loading-text=" Recuperar PO.BOX..."
          >
            Recuperar contraseña.
          </button>
        </form>
      </div>
      <!--/col-sm-6-->
    </div>
    <div v-else id="page-top" class="formulario py-5">
      <div class="container">
        <div class="col text-center py-5">
          <img :src="logo" height="40px" alt />
        </div>
      </div>
      <div class="my-5">
        <div class="message-card container p-3" role="form">
          <h3>
            Vas a recibir un email con las intrucciones para recuperar tu
            contraseña
          </h3>
          <span>Ya puedes iniciar sesión</span>
          <div class="volver-inicio">
            <button class="btn btn-primary" @click="goToLogin">
              Volver al portal
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--/row-->
  </div>
</template>
<script>
import { forgotPassword } from "@/service/api";
export default {
  data() {
    return {
      email: "",
      error: null,
      exito: false,
    };
  },
  methods: {
    submit(evt) {
      evt.preventDefault();
      forgotPassword(this.email).then(() => {
        this.exito = true;
      });
    },
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
<style></style>
